export default {
  state: {
    isLogin: false,
    userInfo: {},
  },
  mutations: {},
  actions: {

  }
}